<template>
  <div class="base-banner-fixed">
    <div class="base-banner-fixed__content">
      <slot name="content"> </slot>
    </div>
    <BaseRoundButton icon="x" isLight isTransparent @click.native="closeBanner" />
  </div>
</template>

<script>
import BaseRoundButton from '@/components/base/BaseRoundButton';

export default {
  name: 'BaseBannerFixed',
  components: {
    BaseRoundButton,
  },
  props: {},
  methods: {
    closeBanner() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.base-banner-fixed {
  background: $color-accent-600;
  box-shadow: $shadow-tooltip;
  color: $color-white;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
  display: flex;
  padding: 4px 0;

  &__content {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    font-size: 14px;
    justify-content: center;
    margin: 0 auto;
    max-width: 900px;
    padding: 8px;
    text-align: center;
  }

  &__text {
    margin: 0;
  }

  &__link {
    margin-left: 24px;

    // Match the white body text so the link reads on the accent background.
    .base-link__element {
      color: $color-white;

      &::after {
        background: $color-white;
      }
    }
  }

  // Match the white body text so the close button reads on the accent background.
  .base-round-button.is-light {
    color: $color-white;
  }
}
</style>
